import { createFileRoute, notFound, redirect } from '@tanstack/react-router';

import { isPersonExecutive } from 'helpers/person';

export const Route = createFileRoute('/_private/')({
  beforeLoad: ({ context, location }) => {
    const { user } = context;
    const role = user.roles?.[0];

    // Executives may still have a placeholder role (e.g. "Banff Candidate", no team_slug).
    // Send them to their people hub before team-only branches — otherwise we fall through with no redirect
    // and this index route renders nothing (blank page).
    if (isPersonExecutive(user)) {
      const userId = user.id ?? user.uuid;
      if (!userId) {
        throw notFound({ throw: true });
      }
      throw redirect({
        params: { userId },
        replace: true,
        to: '/users/$userId/people',
      });
    }

    if (!role) {
      throw redirect({
        replace: true,
        to: '/profile/teams',
      });
    }

    // Check if this is a preregistered user with a recommendation to redirect to
    // Only redirect if onboarding is complete (otherwise they need to go through /signup first)
    const recommendationUuid = localStorage.getItem(
      'preregistration_recommendation_uuid',
    );
    // @ts-ignore
    const metadata = window.Clerk?.user?.publicMetadata || {};
    const onboardingComplete =
      'onboarding_complete' in metadata &&
      metadata.onboarding_complete === true;

    if (recommendationUuid && role.team_slug && onboardingComplete) {
      // Clean up localStorage
      localStorage.removeItem('preregistration_recommendation_uuid');

      // Redirect to the recommendation with the intro request modal open
      throw redirect({
        params: {
          recommendationId: recommendationUuid,
          teamId: role.team_slug,
        },
        replace: true,
        search: {
          dialog: 'introduction-request',
        },
        to: '/teams/$teamId/trending/$recommendationId',
      });
    }

    if (role.team_slug) {
      throw redirect({
        params: {
          teamId: role.team_slug,
        },
        replace: true,
        search: {
          stats: '30d',
          updates: 'unread',
        },
        to: '/teams/$teamId/home',
      });
    }

    if (role.title === 'Unassigned Team Member') {
      throw redirect({
        replace: true,
        to: '/profile/teams',
      });
    }

    if (role.title === 'Banff Admin') {
      throw redirect({
        replace: true,
        search: location.search,
        to: '/home',
      });
    }
  },
});
